import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, Navigate, useLocation } from 'react-router-dom';
import SignUp from './components/SignUp';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import AdminDashboard from './components/AdminDashboard';
import AssignTeacher from './components/AssignTeacher';
import { supabase } from './supabaseClient';
import CustomMeetingRoom from './components/CustomMeetingRoom';
import '../src/styles/Calendar.css';
import './App.css';

function Navigation({ session }) {
  const location = useLocation();

  // Hide navigation on dashboard pages
  if (location.pathname === '/dashboard' || location.pathname === '/admin') {
    return null;
  }

  return (
    <nav>
     
    </nav>
  );
}

function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      setLoading(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return <div className="flex items-center justify-center h-screen">Loading...</div>;
  }

  return (
    <Router>
      <div className="App min-h-screen flex flex-col">
        <Navigation session={session} />

        <main className="flex-grow">
          <Routes>
            
            <Route path="/" element={
              session ? <Navigate to="/dashboard" replace /> : <Login />
            } />
            <Route path="/login" element={
              session ? <Navigate to="/dashboard" replace /> : <Login />
            } />
            <Route path="/signup" element={
              session ? <Navigate to="/dashboard" replace /> : <SignUp />
            } />
            <Route path="/dashboard" element={
              session ? <Dashboard /> : <Navigate to="/login" replace />
            } />
            <Route path="/admin" element={
              session?.user.user_metadata.role === 'admin' ? <AdminDashboard /> : <Navigate to="/dashboard" replace />
            } />
            <Route path="/assign-teacher" element={
              session ? <AssignTeacher /> : <Navigate to="/login" replace />
            } />
            <Route path="/meeting" element={<CustomMeetingRoom />} />
          </Routes>
        </main>

        <style jsx global>{`
          .form-input {
            @apply w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500;
          }
          .form-label {
            @apply block text-sm font-medium text-gray-700 mb-1;
          }
          .form-button {
            @apply w-full px-4 py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors;
          }
        `}</style>
      </div>
    </Router>
  );
}

export default App;